<canvas
  #canvas
  [class.opacity-50]="this.disabled()"
  [class.pointer-events-none]="this.disabled()"
  class="h-52 w-full"></canvas>

<div *transloco="let transloco" class="mt-2">
  <p-button
    (click)="this.clear()"
    [disabled]="this.disabled()"
    [label]="transloco('clear')"
    icon="pi pi-trash"
    severity="secondary"
    type="button">
  </p-button>
</div>
